import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getUiOptions } from '@rjsf/utils';
export default function TitleField({ id, title, uiSchema, }) {
    const uiOptions = getUiOptions(uiSchema);
    return (_jsxs("div", { id: id, className: 'my-1', children: [_jsx("h5", { children: uiOptions.title || title }), _jsx("hr", { className: 'border-0 bg-secondary', style: { height: '1px' } })] }));
}
//# sourceMappingURL=TitleField.js.map